import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/rise-up-king/commas.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

function Clientanimialslider() {
  return (
    <section className="client-animial-slider p-100">
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#202020" }}>Client Success</h2>
            <h3 style={{ color: "#202020" }}>
              The <span className="text-rise-yellow">Continued Growth </span>{" "}
              Speaks Volumes
            </h3>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              //   autoplay={false}
              spaceBetween={20}
              modules={[Autoplay]}
              pagination={{ clickable: true }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1,
                },
                1366: {
                  slidesPerView: 1,
                },
                1600: {
                  slidesPerView: 1,
                },
              }}
              className="client-test"
            >
              <SwiperSlide>
                <div
                  className="client-box"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="stars">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="166"
                      height="30"
                      fill="none"
                      viewBox="0 0 166 30"
                    >
                      <path
                        fill="#D6B156"
                        d="m6.47 29.462 2.385-10.664-8.001-7.173 10.57-.95L15.535.619l4.11 10.058 10.572.948-8.002 7.174 2.386 10.664-9.066-5.655zM74.325 29.462l2.385-10.664-8.001-7.173 10.57-.95L83.392.619l4.11 10.058 10.571.948-8.001 7.174 2.385 10.664-9.065-5.655zM40.397 29.462l2.386-10.664-8.002-7.173 10.571-.95L49.462.619l4.112 10.058 10.57.948-8.001 7.174 2.386 10.664-9.066-5.655zM108.252 29.462l2.386-10.664-8.001-7.173 10.57-.95L117.318.619l4.111 10.058 10.571.948-8.002 7.174 2.386 10.664-9.066-5.655zM142.182 29.462l2.386-10.664-8.002-7.173 10.571-.95L151.248.619l4.111 10.058 10.571.948-8.002 7.174 2.386 10.664-9.066-5.655z"
                      ></path>
                    </svg>
                    <span>(5.0)</span>
                  </div>
                  <p>
                    Working with TekRevol has been an absolute game-changer for
                    us. They not only helped bring our vision of Rise Up Kings
                    to life but also delivered a platform that continues to grow
                    and engage users every day. Their expertise in development
                    and user-centered design has made Rise Up Kings a success
                    story we’re incredibly proud of."
                  </p>
                  {/* <h6>Gray</h6>
                  <h5>Game Developer and Reviewer</h5> */}
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="client-box"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="stars">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="166"
                      height="30"
                      fill="none"
                      viewBox="0 0 166 30"
                    >
                      <path
                        fill="#D6B156"
                        d="m6.47 29.462 2.385-10.664-8.001-7.173 10.57-.95L15.535.619l4.11 10.058 10.572.948-8.002 7.174 2.386 10.664-9.066-5.655zM74.325 29.462l2.385-10.664-8.001-7.173 10.57-.95L83.392.619l4.11 10.058 10.571.948-8.001 7.174 2.385 10.664-9.065-5.655zM40.397 29.462l2.386-10.664-8.002-7.173 10.571-.95L49.462.619l4.112 10.058 10.57.948-8.001 7.174 2.386 10.664-9.066-5.655zM108.252 29.462l2.386-10.664-8.001-7.173 10.57-.95L117.318.619l4.111 10.058 10.571.948-8.002 7.174 2.386 10.664-9.066-5.655zM142.182 29.462l2.386-10.664-8.002-7.173 10.571-.95L151.248.619l4.111 10.058 10.571.948-8.002 7.174 2.386 10.664-9.066-5.655z"
                      ></path>
                    </svg>
                    <span>(5.0)</span>
                  </div>
                  <p>
                    Working with TekRevol has been an absolute game-changer for
                    us. They not only helped bring our vision of Rise Up Kings
                    to life but also delivered a platform that continues to grow
                    and engage users every day. Their expertise in development
                    and user-centered design has made Rise Up Kings a success
                    story we’re incredibly proud of."{" "}
                  </p>
                  {/* <h6>Gray</h6>
                  <h5>Game Developer and Reviewer</h5> */}
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="client-box"
                  style={{
                    backgroundImage: `url(${BgImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="stars">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="166"
                      height="30"
                      fill="none"
                      viewBox="0 0 166 30"
                    >
                      <path
                        fill="#D6B156"
                        d="m6.47 29.462 2.385-10.664-8.001-7.173 10.57-.95L15.535.619l4.11 10.058 10.572.948-8.002 7.174 2.386 10.664-9.066-5.655zM74.325 29.462l2.385-10.664-8.001-7.173 10.57-.95L83.392.619l4.11 10.058 10.571.948-8.001 7.174 2.385 10.664-9.065-5.655zM40.397 29.462l2.386-10.664-8.002-7.173 10.571-.95L49.462.619l4.112 10.058 10.57.948-8.001 7.174 2.386 10.664-9.066-5.655zM108.252 29.462l2.386-10.664-8.001-7.173 10.57-.95L117.318.619l4.111 10.058 10.571.948-8.002 7.174 2.386 10.664-9.066-5.655zM142.182 29.462l2.386-10.664-8.002-7.173 10.571-.95L151.248.619l4.111 10.058 10.571.948-8.002 7.174 2.386 10.664-9.066-5.655z"
                      ></path>
                    </svg>
                    <span>(5.0)</span>
                  </div>
                  <p>
                    Working with TekRevol has been an absolute game-changer for
                    us. They not only helped bring our vision of Rise Up Kings
                    to life but also delivered a platform that continues to grow
                    and engage users every day. Their expertise in development
                    and user-centered design has made Rise Up Kings a success
                    story we’re incredibly proud of."
                  </p>
                  {/* <h6>Gray</h6>
                  <h5>Game Developer and Reviewer</h5> */}
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clientanimialslider;
